import { registerNodeType } from '../../registry'
import { ICONIFY } from '../../../../../Constants/iconify'
import RatingNode from './RatingNode'
import RatingConfig from './RatingConfig'

registerNodeType({
  type: 'RATING',
  label: 'Rating',
  icon: ICONIFY.RATING,
  color: '#EC407A',
  hasOptions: false,
  excludeFields: ['inputMode', 'inputRegex'],
  defaults: {},
  nodeComponent: RatingNode,
  configComponent: RatingConfig,
})
